import Vue from 'vue'
import VueI18n from 'vue-i18n'
import en from './lang/en'
import cn from './lang/zh-CN'
import tw from './lang/zh-TW'
import vn from './lang/vn'
import Models from '@/models'

Vue.use(VueI18n)
Vue.use(Models)

const localDefault = 'en'

const messages = {
  en: {
    ...en
  },
  cn: {
    ...cn
  },
  tw: {
    ...tw
  },
  vn: {
    ...vn
  }
}
const locale = localStorage.getItem('lang') || localDefault

const i18n = new VueI18n({
  locale,
  messages,
  fallbackLocale: localDefault,
  silentFallbackWarn: true
})

export default i18n



// WEBPACK FOOTER //
// ./src/locales/index.js